import { render } from "./index-achievement-statistical-map.vue?vue&type=template&id=862825ba&scoped=true"
import script from "./index-achievement-statistical-map.vue?vue&type=script&lang=js"
export * from "./index-achievement-statistical-map.vue?vue&type=script&lang=js"

import "./index-achievement-statistical-map.vue?vue&type=style&index=0&id=862825ba&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862825ba"]])

export default __exports__